module.exports = __webpack_public_path__ + "static/media/GUIDE_0009_02.e1302ccb.jpg";